module.exports = __webpack_public_path__ + "img/BluePurpleDoubleCircle400.10c39dae.png";